import { IndexedDBService, PulseEnvironment } from '@pulse/browser-shared';
import { PulseModule, TrackerConfigurations, isIndexedDBSupported } from '@pulse/common';
import { trackerProviders } from './factory';
import { trackerConfigs } from './tracker.configuration';

function buildConfig(userConfig: Partial<TrackerConfigurations>): Required<TrackerConfigurations> {
    const config: Required<TrackerConfigurations> = {
        ...trackerConfigs,
        ...userConfig,
    };

    if (config.mode !== 'standard') {
        config.sessionStorageType = 'memory';
        config.attributesStorageType = 'memory';
        config.tabManagerStorageType = 'memory';
        config.trafficSourceDetectorStorageType = 'memory';
        config.eventEnrichment = { tab_id: false, legacy_source: false, referrer: false };
        config.stateEnrichment = {
            device_id: false,
            session_id: config.mode === 'page-session',
            market: true,
            platform: true,
        };

        config.attributeHints = false;
        config.serverCookies = false;
    }

    return config;
}

export const TrackerModule = new PulseModule<TrackerConfigurations>()
    .provide(trackerProviders)
    .beforeInit(buildConfig)
    .onInit(
        async (
            _config: TrackerConfigurations,
            indexedDBService: IndexedDBService,
            env: PulseEnvironment,
        ) => {
            if (await isIndexedDBSupported(env.win, true)) {
                await indexedDBService.connectDB();
            }
        },
        [IndexedDBService, PulseEnvironment],
    );
